/* ETOLIE jesienne liście (25.10.2026, mechanizm uzgodniony przez Claude'a i Codexa; grafiki WebP: Codex).
   Wyłącznie sklep PL, do 01.12.2026 00:00 Europe/Warsaw. Rzadko i płynnie: co kilkanaście–kilkadziesiąt sekund jeden liść
   spada z góry albo przelatuje z boku; z boku czasem para (komputer: rzadko trójka), tylko przy pustym ekranie.
   Twardy limit liści naraz: komputer 3, telefon 2 (obok Halloween do 03.11 było 2 i 1). Tor liczony klatka po klatce
   (requestAnimationFrame); pętla chodzi tylko, gdy jakiś liść jest na ekranie. Przy menu, koszyku, oknie, banerze zgód
   i karcie w tle warstwa jest ukryta, czas i odliczanie stoją; po pauzie > 8 s liście znikają i wracają po 2–5 s.
   „Ogranicz ruch” = brak liści. Koniec sezonu sprawdzany co sekundę także w długo otwartej karcie.
   Konfiguracja: <etolie-liscie data-srcs data-ends-at> ze snippets/etolie-liscie.liquid; window.__LF nadpisuje ją
   tylko w testach. 03.11.2026: pierwsze zdarzenie dopiero po wczytaniu strony (w pauzie odliczanie czeka). */
(function () {
  var host = document.querySelector('etolie-liscie');
  var cfg = Object.assign({
    srcs: host && host.dataset.srcs ? host.dataset.srcs.split(',') : [],
    endsAt: host && host.dataset.endsAt || '2026-12-01T00:00:00+01:00',
    quietUntil: '2026-11-03T00:00:00+01:00',   // cichszy tryb był tylko obok Halloween (zdjęty 03.11)
    firstAt: [5, 9],
    gap: [14, 24], gapQuiet: [18, 28],
    gapMobile: [18, 28], gapMobileQuiet: [20, 32],
    multi: [0.85, 0.13, 0.02], multiMobile: [0.90, 0.10, 0],
    maxAlive: 3, maxAliveQuiet: 2, maxAliveMobile: 2, maxAliveMobileQuiet: 1,
    sideShare: 0.5,
    size: [22, 34], sizeMobile: [20, 26],
    fallSeconds: [18, 24], crossSeconds: [7, 10], crossSecondsMobile: [5.5, 7.5],
    sway: [20, 40], swayMobile: [12, 24],
    opacity: [0.90, 0.96],
    demo: null, force: false
  }, window.__LF || {});
  if (!cfg.srcs.length || document.querySelector('.etolie-liscie__layer')) return;
  if (!cfg.force && Date.now() >= Date.parse(cfg.endsAt)) return;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;

  var style = document.createElement('style');
  style.textContent =
    '.etolie-liscie__layer{position:fixed;inset:0;z-index:9;overflow:hidden;pointer-events:none;contain:strict}' +
    '.etolie-liscie__layer.is-off{visibility:hidden}' +
    '.etolie-liscie__leaf{position:absolute;left:0;top:0;opacity:0;will-change:transform,opacity}' +
    '.etolie-liscie__leaf img{display:block;width:100%;height:100%;max-width:none;max-height:none;margin:0;will-change:transform}';
  document.head.appendChild(style);
  var layer = document.createElement('div');
  layer.className = 'etolie-liscie__layer';
  layer.setAttribute('aria-hidden', 'true');
  document.body.appendChild(layer);

  var TAU = Math.PI * 2;
  var mobile = function () { return innerWidth < 750; };
  var rnd = function (a, b) { return a + Math.random() * (b - a); };
  var pick = function (r) { return rnd(r[0], r[1]); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var quiet = function () { return Date.now() < Date.parse(cfg.quietUntil); };
  var leaves = [], clock = 0, lastNow = 0, raf = 0, timer = 0, dueAt = 0, remainingMs = -1;
  var ended = false, paused = false, pausedAt = 0, loaded = document.readyState === 'complete';
  var imgs = cfg.srcs.map(function (s) { var i = new Image(); i.decoding = 'async'; i.src = s; return i; });

  // kind: 'fall' (z góry) albo 'side' (z boku, dir 1 = z lewej na prawą, -1 = z prawej na lewą)
  function spawn(kind, dir, delay, yBase) {
    var m = mobile(), vw = innerWidth, vh = innerHeight, s = pick(m ? cfg.sizeMobile : cfg.size);
    var L = { kind: kind, dir: dir, b: clock + delay, s: s, vw: vw, vh: vh, o: pick(cfg.opacity),
      th0: rnd(0, 360), rx0: rnd(0, TAU), ry0: rnd(0, TAU), fF: rnd(25, 45),
      pF: kind === 'fall' ? rnd(3.2, 4.8) : rnd(2.4, 3.6) };
    if (kind === 'fall') {
      L.x0 = rnd(0.06, 0.94) * vw - s / 2; L.y0 = -1.5 * s;
      L.vy = (vh + 3 * s) / pick(cfg.fallSeconds);
      L.A = pick(m ? cfg.swayMobile : cfg.sway); L.P = rnd(2.6, 4.2); L.ph = rnd(0, TAU); L.ph2 = rnd(0, TAU);
      L.D = rnd(-16, 16); L.w0 = rnd(-10, 10);
    } else {
      L.x0 = dir > 0 ? -2 * s : vw + s; L.y0 = yBase + rnd(-0.08, 0.08) * vh;
      L.T = pick(m ? cfg.crossSecondsMobile : cfg.crossSeconds); L.len = vw + 3 * s;
      L.vy = rnd(22, 50); L.g = rnd(4, 9); L.B = rnd(14, 30); L.P = rnd(1.4, 2.4); L.ph = rnd(0, TAU);
      L.w0 = dir * rnd(25, 55);
    }
    L.el = document.createElement('div'); L.el.className = 'etolie-liscie__leaf';
    L.el.style.width = L.el.style.height = Math.round(s) + 'px';
    var img = imgs[Math.floor(Math.random() * imgs.length)].cloneNode();
    img.alt = ''; img.width = img.height = Math.round(s); img.draggable = false;
    L.img = img; L.el.appendChild(img); layer.appendChild(L.el); leaves.push(L);
    run();
  }

  // Położenie liścia po czasie tau (s) od narodzin. Zwraca false, gdy liść jest już poza ekranem.
  function place(L, tau) {
    var x, y, th, o = L.o, vh = L.vh, s = L.s;
    if (L.kind === 'fall') {
      var w = TAU / L.P;
      x = L.x0 + L.D * tau + L.A * Math.sin(w * tau + L.ph) + 0.45 * L.A * Math.sin(w * tau / 3.7 + L.ph2);
      var vx = L.D + L.A * w * Math.cos(w * tau + L.ph) + 0.45 * L.A * (w / 3.7) * Math.cos(w * tau / 3.7 + L.ph2);
      // szybciej w środku wahnięcia, wolniej na skrajach (ślizg jak wahadło)
      y = L.y0 + L.vy * tau + (L.vy / (4 * w)) * Math.sin(2 * w * tau + 2 * L.ph);
      th = L.th0 + L.w0 * tau + clamp(0.5 * vx, -38, 38);
      if (y > vh + s) return false;
    } else {
      var sn = Math.min(tau / L.T, 1), p = 0.75 * sn + 0.25 * (1 - (1 - sn) * (1 - sn));
      x = L.x0 + L.dir * L.len * p;
      var wv = TAU / L.P;
      y = L.y0 + L.vy * tau + 0.5 * L.g * tau * tau + L.B * Math.sin(wv * tau + L.ph);
      th = L.th0 + L.w0 * (0.5 * tau + 1.5 * (1 - Math.exp(-tau / 3))) + 0.25 * L.B * wv * Math.cos(wv * tau + L.ph);
      if (sn >= 1 || y > vh + s) return false;
      if (sn > 0.86) o *= (1 - sn) / 0.14;
    }
    var tin = Math.min(1, tau / 0.9); o *= tin * (2 - tin);
    var fade = 0.16 * vh; if (y > vh - fade) o *= Math.max(0, (vh + s - y) / (fade + s));
    var rx = L.fF * Math.sin(TAU * tau / L.pF + L.rx0), ry = 0.35 * L.fF * Math.sin(TAU * tau / (1.7 * L.pF) + L.ry0);
    L.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + th.toFixed(1) + 'deg)';
    L.el.style.opacity = o.toFixed(3);
    L.img.style.transform = 'perspective(300px) rotateX(' + rx.toFixed(1) + 'deg) rotateY(' + ry.toFixed(1) + 'deg)';
    return true;
  }

  function frame(now) {
    raf = 0;
    if (paused || ended) return;
    var dt = clamp((now - lastNow) / 1000, 0, 0.05); lastNow = now; clock += dt;
    for (var i = leaves.length - 1; i >= 0; i--) {
      var L = leaves[i], tau = clock - L.b;
      if (tau >= 0 && !place(L, tau)) { L.el.remove(); leaves.splice(i, 1); }
    }
    if (leaves.length) raf = requestAnimationFrame(frame);
  }
  function run() { if (!raf && !paused && !ended && leaves.length) { lastNow = performance.now(); raf = requestAnimationFrame(frame); } }

  function gapRange() { var m = mobile(), q = quiet(); return m ? (q ? cfg.gapMobileQuiet : cfg.gapMobile) : (q ? cfg.gapQuiet : cfg.gap); }
  function limit() { var m = mobile(), q = quiet(); return m ? (q ? cfg.maxAliveMobileQuiet : cfg.maxAliveMobile) : (q ? cfg.maxAliveQuiet : cfg.maxAlive); }
  // Zdarzenie: z góry zawsze jeden liść; z boku 1, 2 albo 3 (trójka tylko na komputerze), grupa tylko przy
  // pustym ekranie. Limit liczy też liście czekające na opóźnione wejście. Brak miejsca = próba pominięta, bez kolejki.
  function fire(d) {
    var m = mobile(), free = limit() - leaves.length;
    if (free <= 0) return false;
    var kind = d && d.kind || (Math.random() < cfg.sideShare ? 'side' : 'fall'), n = 1;
    if (kind === 'side') {
      var probs = m ? cfg.multiMobile : cfg.multi, r = Math.random();
      n = d && d.n || (r < probs[0] ? 1 : r < probs[0] + probs[1] ? 2 : 3);
      if (n === 3 && (m || quiet())) n = 2;
      if (n > 1 && leaves.length) n = 1;
      n = Math.min(n, free);
    }
    var dir = d && d.dir || (Math.random() < 0.5 ? 1 : -1), yBase = rnd(0.1, 0.45) * innerHeight;
    for (var i = 0; i < n; i++) spawn(kind, dir, i === 0 ? 0 : rnd(0.35, 1.2) * i, yBase);
    return true;
  }
  function event() {
    timer = 0; dueAt = 0;
    if (ended) return;
    if (paused) { remainingMs = 0; return; }   // zdarzenie trafiło w pauzę: odpali zaraz po wznowieniu
    fire();
    schedule(pick(gapRange()));
  }
  function schedule(sec) { clearTimeout(timer); dueAt = Date.now() + sec * 1000; timer = setTimeout(event, sec * 1000); }

  function blocked() {
    var h = document.documentElement, banner = document.getElementById('shopify-pc__banner');
    return h.matches('.etolie-navigation-open, .etolie-filter-open, .etolie-social-open') ||
      !!document.querySelector('dialog[open], shopify-chat[open]') ||
      !!(banner && getComputedStyle(banner).display !== 'none');
  }
  function sync() {
    if (ended) return;
    if (!cfg.force && Date.now() >= Date.parse(cfg.endsAt)) { stop(); return; }
    var blk = blocked(), p = blk || document.hidden;
    layer.classList.toggle('is-off', blk);
    if (p === paused) return;
    paused = p;
    if (paused) {
      pausedAt = Date.now();
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      remainingMs = timer ? Math.max(0, dueAt - Date.now()) : -1;
      clearTimeout(timer); timer = 0;
      return;
    }
    if (Date.now() - pausedAt > 8000) {
      leaves.forEach(function (L) { L.el.remove(); }); leaves = [];
      if (!cfg.demo && loaded) schedule(rnd(2, 5));   // przed load start i tak nastąpi po wczytaniu
    } else if (remainingMs >= 0) schedule(remainingMs / 1000);
    remainingMs = -1;
    run();
  }
  var mo = new MutationObserver(sync);
  var tick = setInterval(sync, 1000);
  function stop() {
    ended = true; clearTimeout(timer); if (raf) cancelAnimationFrame(raf);
    clearInterval(tick); mo.disconnect();
    layer.remove(); style.remove();
  }

  document.addEventListener('visibilitychange', sync);
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('toggle', sync, true);
  reduced.addEventListener('change', function () { if (reduced.matches) stop(); });
  // Najpierw harmonogram, potem sync(): gdy baner zgód jest widoczny od startu, pauza ma już timer do zamrożenia (Codex, runda 3).
  if (cfg.demo) cfg.demo.forEach(function (d) { setTimeout(function () { if (!ended && !paused) fire(d); }, d.at * 1000); });
  // pierwsze zdarzenie dopiero po wczytaniu strony (zdjęcia, skrypty); w pauzie odliczanie czeka na wznowienie
  else if (loaded) schedule(pick(cfg.firstAt));
  else addEventListener('load', function () {
    loaded = true;
    if (ended) return;
    var sec = pick(cfg.firstAt);
    if (paused) remainingMs = sec * 1000; else schedule(sec);
  }, { once: true });
  sync();
  window.__LF_stop = stop;
  window.__LF_state = function () { return { alive: leaves.length, paused: paused, clock: clock }; };
})();
